// Select elements
const headerLayout = document.querySelector('.header-layout--center');
const logoImage = document.querySelector('.site-logo__img');
const dropdowns = document.querySelectorAll('.media-menu');
const initialHeaderHeight = 115;
const minHeaderHeight = 80;
const initialLogoHeight = 95;
const minLogoHeight = 70;
const initialDropdownTop = '234px';
const shrunkDropdownTop = '199px';
const shrinkThreshold = 105;
const expandThreshold = 70;

let isShrunk = false;

window.addEventListener('scroll', function () {
  const scrollY = window.scrollY;

  if (!isShrunk && scrollY > shrinkThreshold) {
    // Shrink header and logo
    headerLayout.style.maxHeight = `${minHeaderHeight}px`;
    logoImage.style.maxHeight = `${minLogoHeight}px`;

    // Update dropdown position
    dropdowns.forEach(dropdown => {
      dropdown.style.top = shrunkDropdownTop;
    });

    isShrunk = true;
  } else if (isShrunk && scrollY < expandThreshold) {
    // Expand header and logo
    headerLayout.style.maxHeight = `${initialHeaderHeight}px`;
    logoImage.style.maxHeight = `${initialLogoHeight}px`;

    // Reset dropdown position
    dropdowns.forEach(dropdown => {
      dropdown.style.top = initialDropdownTop;
    });

    isShrunk = false;
  }
});
